import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { TableModule } from 'primeng/table';

import { PageHeader } from '@core/components/page-header/page-header';
import { PaymentHistoryListQuery, PaymentHistorySummaryV1 } from '@core/models/payment-history';
import { PaymentsService } from '@core/services/payments/payments';

@Component({
  selector: 'yt-payments-list',
  imports: [CurrencyPipe, DatePipe, FormsModule, ButtonModule, InputTextModule, MessageModule, TableModule, PageHeader],
  templateUrl: './payments-list.html',
  styleUrl: './payments-list.scss'
})
export class PaymentsList {
  private readonly paymentsService = inject(PaymentsService);

  protected readonly paging = this.paymentsService.paging;
  protected readonly loading = signal(false);
  protected readonly allPayments = signal<PaymentHistorySummaryV1[]>([]);

  protected readonly customerIdFilter = signal('');
  protected readonly referenceIdFilter = signal('');

  constructor() {
    this.loadPayments();
  }

  protected hasActiveFilters(): boolean {
    return this.customerIdFilter() !== '' || this.referenceIdFilter() !== '';
  }

  protected clearFilters(): void {
    this.customerIdFilter.set('');
    this.referenceIdFilter.set('');
    this.allPayments.set([]);
    this.loadPayments();
  }

  protected applyFilters(): void {
    this.allPayments.set([]);
    this.loadPayments();
  }

  protected loadMore(): void {
    const nextToken = this.paging().nextToken;
    if (nextToken) {
      this.loadPayments(nextToken);
    }
  }

  private loadPayments(nextToken?: string): void {
    this.loading.set(true);
    const query: PaymentHistoryListQuery = {};
    const customerId = this.customerIdFilter().trim();
    const referenceId = this.referenceIdFilter().trim();
    if (customerId) query.youtopiaCustomerId = customerId;
    if (referenceId) query.referenceId = referenceId;
    if (nextToken) query.nextToken = nextToken;

    this.paymentsService.getPaymentsList(query).subscribe({
      next: () => {
        this.allPayments.update((existing) => [...existing, ...this.paymentsService.payments()]);
        this.loading.set(false);
      },
      error: () => this.loading.set(false)
    });
  }
}
